import getRandomIntInRange from './getRandomIntInRange';

export default getRandomIntInRange;
